import { pricingDrawerUiConstaints } from '@constants/pricing-drawer-ui';
import { billingService } from '@services';
import { handleApiError } from '@helpers/api';

const setOpen = data => {
    return { type: pricingDrawerUiConstaints.SET_PRICING_DRAWER_OPEN, payload: data };
};

const setStep = data => {
    return { type: pricingDrawerUiConstaints.SET_PRICING_DRAWER_STEP, payload: data };
};

const success = data => {
    return { type: pricingDrawerUiConstaints.PRICING_DRAWER_DATA_SUCCESS, payload: data };
};

function getUpdateSubscriptionData(data) {
    return dispatch => {
        return billingService.getUpdateSubscriptionData(data).then(
            data => dispatch(success(data)),
            error => {
                handleApiError(error, 'alertMessages.updateFail');
                dispatch(setStep(0));
            },
        );
    };
}

export const pricingDrawerUiActions = {
    setOpen,
    setStep,
    getUpdateSubscriptionData,
};
